import { css } from 'emotion'

export const showLabelOnHover = (label, { left = 28 } = {}) => {
  const width = label.length * 20

  return css`
    position: relative;
    z-index: 1;

    &::after {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: ${width}px;
      height: 24px;
      content: '';
      background-color: transparent;
      left: 0;
      border-radius: 2px !important;
      transition: background-color 0.3s ease 0s, left 0.3s ease-out 0s;
      z-index: 0;
  }

    &:hover {
      &::after {
        content: '${label}';
        background-color: rgba(255, 255, 255, 0.8);
        left: ${left}px;
      }
    }
  `
}
